import { Navigate, Route, Routes } from 'react-router-dom';
import { UsersPage } from './UsersPage';
import { AccountsPage } from './AccountsPage';
import { UsagePage } from './UsagePage';
import { OverridesPage } from './OverridesPage';
import { AnalyticsPage } from './AnalyticsPage';
import { CancellationsPage } from './CancellationsPage';
import { ProvisioningPage } from './ProvisioningPage';
import { PlanLimitsPage } from './PlanLimitsPage';
import { ContentPage } from './ContentPage';
import styles from './Admin.module.css';
import { useTabTitle } from '../../lib/tabTitle';

/**
 * Admin panel root layout. Full-width content column; the section nav
 * (Users / Accounts / Usage / Cancellations / Analytics / Overrides) now
 * lives in the main app sidebar's staff-gated "Admin" section rather than an
 * interior aside here — one nav surface instead of two.
 *
 * Gated client-side via `RequireStaff` (the router wraps this in it);
 * server-side enforcement via `requireStaff` middleware on every
 * /admin/* endpoint, so bypassing the React guard still 404s the
 * data fetches.
 */
export function AdminLayout() {
  // This tab's title (TOADO-905).
  useTabTitle({ parts: ['Admin'] });
  return (
    <div className={styles.page}>
      <main className={styles.content}>
        <Routes>
          {/* Land /admin on the first tab so a sidebar item highlights and the
              route is unambiguous (the interior aside that used to imply this
              is gone). */}
          <Route path="/" element={<Navigate to="users" replace />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="usage" element={<UsagePage />} />
          <Route path="cancellations" element={<CancellationsPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="overrides" element={<OverridesPage />} />
          <Route path="plan-limits" element={<PlanLimitsPage />} />
          <Route path="provisioning" element={<ProvisioningPage />} />
          <Route path="content" element={<ContentPage />} />
        </Routes>
      </main>
    </div>
  );
}
